module.exports = __webpack_public_path__ + "media/images/pages/fcr/doctor-5-a1fe8ede02e32c3983dfcc83b79951e4.png";